import trackConversion from 'utils/trackConversion';
import userService from 'resources/user/user.service';
import * as authService from 'resources/auth/auth.service';
import { USER_STATUSES } from 'resources/user/user.constants';
import { DEAL_EVENT_TYPES } from 'resources/deal-event/deal-event.constants';
import dealService from 'resources/deal/deal.service';
import dealEventService from 'resources/deal-event/deal-event.service';
import { getFullName, isClient } from 'resources/user/user.helpers';

const signupInvitee = async ({ inviteeId, password }) => {
  
  const invitee = await userService.findById(inviteeId);

  if (!invitee) {
    return {
      isBadRequest: true,
      errorMessage: 'User not found.',
    };
  }

  const signupResult = await authService.updateUser({ password });

  if (signupResult.isBadRequest) {
    return null;
  }

  const updatedUser = await userService.updateUser({
    id: invitee.id,
    status: USER_STATUSES.REGISTERED,
    app_state: {
      ...invitee.app_state,
      is_email_verified: true,
    },
  });

  trackConversion(updatedUser.email);

  if (isClient(updatedUser)) {
    const deals = await dealService.getDealsByClientIds([updatedUser.id], updatedUser.company_id);

    deals.map(async (deal) => {
      await dealEventService.createDealEvent({
        type: DEAL_EVENT_TYPES.CLIENT_IS_JOINED,
        dealId: deal.id,
        companyId: deal.company_id,
        createdBy: updatedUser.id,
        data: { name: getFullName(updatedUser) },
      });
    });
  }

  return updatedUser;
};

export {
  signupInvitee,
};
